import React, { useMemo } from 'react';
import { ProductFruits } from 'react-product-fruits';
import { useAuth0 } from '@auth0/auth0-react';
import { useFetchUserAbout } from 'utils/hooks';

function SpateProductFruits() {
    const { user } = useAuth0();
    const { data } = useFetchUserAbout({ enabled: !!user });
    const email = user?.email;
    const username = data?.product_fruits_identify_user?.username;
    const hmacHash = data?.product_fruits_identify_user?.hmac_hash;
    const productFruitsUser = useMemo(() => {
        if (!(email && username && hmacHash)) return null;
        return {
            email: user.email,
            username,
            hmac: { hash: hmacHash },
        };
    }, [email, username, hmacHash]);
    if (!productFruitsUser) return null;
    return (
        <ProductFruits
            workspaceCode="W0jqNHoUOufUcmCW"
            language="en"
            user={productFruitsUser}
        />
    );
}

export default SpateProductFruits;
